/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_EmptyInputs */

const en_colleague_empty = /** @type {(inputs: Colleague_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No open colleague tickets for this day`)
};

const ja_colleague_empty = /** @type {(inputs: Colleague_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この日の同僚の未完了チケットはありません`)
};

const fr_colleague_empty = /** @type {(inputs: Colleague_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun ticket ouvert de collègue pour ce jour`)
};

const de_colleague_empty = /** @type {(inputs: Colleague_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine offenen Kollegen-Tickets für diesen Tag`)
};

/**
* | output |
* | --- |
* | "No open colleague tickets for this day" |
*
* @param {Colleague_EmptyInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_empty = /** @type {((inputs?: Colleague_EmptyInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_EmptyInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_empty(inputs)
	if (locale === "ja") return ja_colleague_empty(inputs)
	if (locale === "fr") return fr_colleague_empty(inputs)
	return de_colleague_empty(inputs)
});